import { render, staticRenderFns } from "./GlobalSearchIcon.vue?vue&type=template&id=83d99698&"
import script from "./GlobalSearchIcon.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports